import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { AdapterRegistry } from '../adapter-registry';
import { LinkedServiceAdapter } from './linkedservice.adapter';
import { Model } from '../../backendmodel';
import { TridentSparkJobDefinitionLinkedService } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(TridentSparkJobDefinitionLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {},
            parameters: '*'
        }
    }
})
export class TridentSparkJobDefinitionLinkedServiceAdapter extends LinkedServiceAdapter<TridentSparkJobDefinitionLinkedService> {

    protected modelConstructor(): new () => TridentSparkJobDefinitionLinkedService {
        return TridentSparkJobDefinitionLinkedService;
    }

    protected model(): IModel {
        return TridentSparkJobDefinitionLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(_linkedService: TridentSparkJobDefinitionLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        return linkedServiceResource;
    }
    
    protected async propertiesToModelAsync(_linkedServiceResource: Model.LinkedServiceResource, linkedService: TridentSparkJobDefinitionLinkedService): Promise<TridentSparkJobDefinitionLinkedService> {
        return linkedService;
    }
}